import React, { useEffect, useRef } from 'react';

import { SlideOverContentProps } from './types';
import { composeClassName } from '@/utils/util_helpers';

const SlideOverContent: React.FC<SlideOverContentProps> = ({
  className,
  children,
  scrollToEnd = false,
  ...props
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollToEnd) return;
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [children, scrollToEnd]);

  return (
    <div
      ref={containerRef}
      className={composeClassName(
        'min-h-0 flex-1 overflow-y-auto flex w-full flex-col px-4 py-3 pb-10',
        className && className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export { SlideOverContent };
